import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Loading } from "../components/common/Loading";
import { useNavigate, useSearchParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { sendOtp } from "../services/beneficiaries";
import { api, handleToast } from "../services/config";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import { contextApi } from "../context/contextApi";
import { useContext } from "react";
import { AllBags, getWalletsByType } from "../services/bags";

export const Convert = () => {
  const location = useLocation();
  const [timer, setTimer] = useState(0);
  const [boxes, setBoxes] = useState([]);
  const [uniqueTypes, setUniqueTypes] = useState([]); // برای نگه‌داری type های یکتا
  const [filteredWallets, setFilteredWallets] = useState([]); // برای نگه‌داری wallets فیلتر شده
  const context = useContext(contextApi);
  const { title } = location.state || {};
  const {
    register,
    handleSubmit,
    watch,
    control,
    setValue,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" });
  const [load, setLoad] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [defaultSet, setDefaultSet] = useState(false); // برای جلوگیری از تنظیم مجدد پیش‌فرض

  const [isDark, setIsDark] = useState(
    () =>
      typeof window !== "undefined" && document.body.classList.contains("dark")
  );

  useEffect(() => {
    const checkDark = () => setIsDark(document.body.classList.contains("dark"));
    checkDark();
    const observer = new MutationObserver(() => {
      checkDark();
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  const getGoldMelted = async () => {
    try {
      let res = await AllBags();
      console.log(res.data.data);
      setBoxes(res.data.data);

      // استخراج type های یکتا از داده‌ها
      const uniqueTypeMap = new Map();
      res.data.data.forEach((item) => {
        if (!uniqueTypeMap.has(item.type)) {
          uniqueTypeMap.set(item.type, {
            type: item.type,
            type_text: item.type_text,
          });
        }
      });
      setUniqueTypes(Array.from(uniqueTypeMap.values()));
    } catch (error) {}
  };

  useEffect(() => {
    const storedStartTime = localStorage.getItem("startTime");
    const currentTime = Math.floor(Date.now() / 1000);
    const elapsedTime = currentTime - parseInt(storedStartTime, 10);
    if (elapsedTime < 120) {
      setTimer(120 - elapsedTime);
    }
    getGoldMelted();
  }, []);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  // تنظیم پیش‌فرض "نوع کیف پول" بر اساس id از query parameter (فقط اگر id وجود داشته باشد)
  useEffect(() => {
    const idFromQuery = searchParams.get("id");
    if (idFromQuery && uniqueTypes.length > 0 && !defaultSet) {
      // پیدا کردن type که با id از query parameter مطابقت دارد
      const matchingType = uniqueTypes.find(
        (type) => type.type.toString() === idFromQuery
      );
      if (matchingType) {
        setValue("two", matchingType.type.toString());
        setDefaultSet(true); // علامت‌گذاری که پیش‌فرض تنظیم شده است
      }
    }
  }, [uniqueTypes, searchParams, setValue, defaultSet]);

  // دریافت wallets از API بر اساس type انتخاب شده
  const selectedWalletType = watch("two");
  useEffect(() => {
    const fetchWallets = async () => {
      if (selectedWalletType) {
        try {
          // ریست کردن فیلد "کیف پول" وقتی "نوع کیف پول" تغییر می‌کند
          setValue("one", "");
          setFilteredWallets([]);

          // ارسال درخواست به API برای دریافت wallets بر اساس type
          const res = await getWalletsByType(selectedWalletType);
          if (res && res.data && res.data.data) {
            setFilteredWallets(res.data.data);
          }
        } catch (error) {
          console.error("Error fetching wallets:", error);
          setFilteredWallets([]);
        }
      } else {
        setFilteredWallets([]);
        setValue("one", "");
      }
    };

    fetchWallets();
  }, [selectedWalletType, setValue]);

  // ساخت dataForm به صورت داینامیک
  const dataForm = [
    {
      title: "نوع کیف پول",
      registerOption: "two",
      options: { required: true },
      messageError: "لطفا یک گزینه را انتخاب کنید",
      type: "select",
      select: uniqueTypes.map((item) => ({
        id: item.type,
        title: item.type_text,
      })),
      inputType: "text",
    },
    {
      title: "کیف پول",
      registerOption: "one",
      options: { required: true },
      messageError: "این فیلد اجباری می باشد",
      type: "select",
      select: filteredWallets.map((item) => ({
        id: item.id,
        dataId: item.type,
        title: item.name,
      })),
      inputType: "text",
    },
    {
      title: "مبلغ(ریال)",
      registerOption: "five",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "input",
      inputType: "number",
    },
    {
      title: "تبدیل به‌",
      registerOption: "three",
      options: { required: true },
      messageError: "این فیلد اجباری می باشد",
      type: "input",
      inputType: "text",
    },
    {
      title: "کدتایید",
      registerOption: "six",
      options: { required: true },
      messageError: "این فیلد اجباری می باشد",
      type: "input",
      inputType: "number",
      btn: true,
    },
  ];

  const handlSendOTP = async () => {
    const typeWallet = watch("two");
    const wallet = watch("one");
    const amount = watch("five");
    const convertTo = watch("three");

    // چک کردن اینکه همه فیلدها پر شده باشند
    const missingFields = [];

    if (!typeWallet) {
      missingFields.push("نوع کیف پول");
    }
    if (!wallet) {
      missingFields.push("کیف پول");
    }
    if (!amount || amount === "") {
      missingFields.push("مبلغ");
    }
    if (!convertTo || convertTo.trim() === "") {
      missingFields.push("تبدیل به");
    }

    if (missingFields.length > 0) {
      handleToast("error", `لطفا ${missingFields.join("، ")} را وارد کنید`);
      return;
    }

    const startTime = Math.floor(Date.now() / 1000);
    localStorage.setItem("startTime", startTime.toString());
    setTimer(120);
    const bodyOtp = {
      mobile: localStorage.mobile, // در صورتی که کاربر وارد نشده بود
    };
    try {
      setLoad(true);
      await sendOtp(bodyOtp);
      handleToast("success", "کد ارسال شده را وارد کنید");
    } catch (error) {
      setTimer(0);
      localStorage.removeItem("startTime");
      handleToast("error", "خطا در ارسال کد تایید");
    }
    setTimeout(() => {
      setLoad(false);
    }, 500);
  };

  const onSubmit = async (data) => {
    // پیدا کردن type از data.two (نوع کیف پول انتخاب شده)
    const selectedType = +data.two;
    const formData = {
      otp: +data.six,
      asset_id: +data.one,
      type: selectedType, // اضافه کردن type به formData
      amount: +data.five,
      convert_to: data.three,
    };

    try {
      const response = await api.post("swap", formData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: `Bearer ${localStorage.getItem("login")}`,
        },
      });
      console.log(response.data);
      handleToast("success", "درخواست شما ثبت گردید");
      setTimeout(() => {
        navigate("/");
      }, 1500);
    } catch (error) {
      console.log(error.response.data.message);
      handleToast("error", error.response.data.message);
    }
  };

  const handleClick = (buttonName) => {
    context.recordClick(buttonName);
  };

  return (
    <div className="w-full h-screen bg-white dark:bg-[#0D1117]">
      <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{
          position: "fixed",
          top: "20px",
          left: "20px",
          zIndex: 9999,
        }}
      />
      <div className="mb-6 p-3 lg:p-6">
        <h1
          className="
    relative inline-block text-3xl font-bold mb-6 
    text-[#0010c6] dark:text-white
    after:content-[''] after:block after:w-full after:h-[4px] 
    after:bg-[#0010c6] after:mt-[10px] dark:after:bg-[#ffffff]"
        >
          درخواست تبدیل
        </h1>
      </div>
      <div
        className={`form  rounded-2xl shadow p-3 max-w-full md:w-3/4 lg:w-2/4 mx-10 md:mx-auto md:p-3  lg:p-6 ${
          isDark ? "card" : "card2"
        }`}
      >
        <Loading show={load} />
        <span className=" text-[#0010c6] dark:text-white">در خواست تبدیل</span>
        <form onSubmit={handleSubmit(onSubmit)} className="mt-3">
          {dataForm.map((item, index) => {
            return (
              <div key={index}>
                <label
                  htmlFor=""
                  className="text-xs text-[#0010c6] dark:text-white m-0 3"
                >
                  {item.title}
                </label>
                {item.type === "select" ? (
                  <div>
                    <select
                      name={item.registerOption}
                      {...register(item.registerOption, item.options)}
                      disabled={
                        item.registerOption === "one" && !selectedWalletType
                      }
                      className={`w-full border rounded-md px-2 py-1 text-xs text-black bg-gray-100 dark:bg-gray-400  font-normal outline-none ${
                        (errors[item.registerOption] &&
                          "bg-red-100 border border-red-400") ||
                        (item.registerOption === "one" && !selectedWalletType
                          ? "opacity-50 cursor-not-allowed"
                          : "")
                      }`}
                      id=""
                    >
                      <option value="" hidden>
                        انتخاب کنید
                      </option>

                      {item.select?.map((items) => {
                        return (
                          <option
                            key={items.id || items.dataId}
                            value={items.id}
                          >
                            {items.title}
                          </option>
                        );
                      })}
                    </select>
                    {errors[item.registerOption] && (
                      <p className="text-red-400 text-xs">
                        {item.messageError}
                      </p>
                    )}
                  </div>
                ) : (
                  <div className="relative" key={index}>
                    {item.registerOption === "five" ? (
                      <Controller
                        control={control}
                        name={item.registerOption}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <NumericFormat
                            className={`${
                              item.btn ? " w-2/4 md:w-4/5" : " w-full"
                            } border rounded-md text-black bg-gray-100 dark:bg-gray-400 px-2 py-1 text-xs placeholder:text-left font-normal outline-none ${
                              errors["money"] &&
                              "bg-red-100 border border-red-400"
                            }`}
                            thousandSeparator=","
                            value={value}
                            onValueChange={(values) => {
                              onChange(values.value);
                            }}
                          />
                        )}
                      />
                    ) : (
                      <input
                        {...register(item.registerOption, item.options)}
                        placeholder={item.placeholder || ""}
                        type={item.inputType}
                        className={`${
                          item.btn ? " w-2/4 md:w-4/5" : "  w-full"
                        } border rounded-md px-2 py-1 text-black bg-gray-100 dark:bg-gray-400 text-xs placeholder:text-left font-normal outline-none ${
                          errors[item.registerOption] &&
                          "bg-red-100 border border-red-400"
                        }`}
                      />
                    )}
                    {item.btn && (
                      <button
                        type="button"
                        disabled={timer > 0}
                        className={`text-center bg-blue-500 w-5/12 md:w-1/6 float-left py-1 mr-auto text-white rounded text-sm ${
                          timer > 0
                            ? "opacity-50 bg-gray-500 text-[10px] cursor-not-allowed"
                            : ""
                        }`}
                        onClick={handlSendOTP}
                      >
                        ارسال کد تایید
                        {timer > 0 && ` (${timer}s)`}
                      </button>
                    )}
                    {errors[item.registerOption] && (
                      <p className="text-red-400 text-xs">
                        {item.messageError}
                      </p>
                    )}
                  </div>
                )}
              </div>
            );
          })}
          <div className="flex flex-col md:flex-row mt-5 w-full gap-10">
            <button
              className="btn-add text-center mt-3 shadow  bg-red-600 w-full rounded text-white p-1 text-sm hover:bg-red-700"
              onClick={() => navigate("/")}
            >
              انصراف
            </button>
            <input
              type="submit"
              onClick={() => {
                handleClick("ارسال در در خواست تبدیل");
              }}
              value={"ارسال"}
              disabled={!isValid}
              className="btn-add text-center mt-3 shadow  bg-green-600 w-full rounded text-white p-1 text-sm hover:bg-green-700"
            />
          </div>
        </form>
      </div>
    </div>
  );
};
